import api from './api';

const ruleQ = (ruleId) => (ruleId ? `?ruleId=${ruleId}` : '');

const iataProfileService = {
    list:    (ppId, ruleId)          => api.get(`/paymentporter/${ppId}/iata-profiles${ruleQ(ruleId)}`),
    getById: (ppId, profileId)       => api.get(`/paymentporter/${ppId}/iata-profiles/${profileId}`),
    create:  (ppId, data, ruleId)    => api.post(`/paymentporter/${ppId}/iata-profiles${ruleQ(ruleId)}`, data),
    update:  (ppId, profileId, data) => api.put(`/paymentporter/${ppId}/iata-profiles/${profileId}`, data),
    remove:  (ppId, profileId)       => api.delete(`/paymentporter/${ppId}/iata-profiles/${profileId}`),
};

export default iataProfileService;
